import { API_BASE_PATH } from '@cqinv/shared';
import { apiFetch } from '../../lib/api';
import type { SesionMe } from '../session/api';
import { cabecerasDeEscritura } from '../masters/api';

export const brandingApi = {
  guardar: (sesion: SesionMe, body: Record<string, unknown>): Promise<{ theme: { appName: string; showPoweredBy: boolean }; warnings: { pair: string }[] }> =>
    apiFetch(`${API_BASE_PATH}/branding/themes/company`, {
      method: 'PUT',
      headers: cabecerasDeEscritura(sesion),
      body: JSON.stringify(body),
    }),
};

export const notificationsApi = {
  listar: (sesion: SesionMe): Promise<{ items: { id: string; title: string; kind: string; linkPath: string | null }[] }> =>
    apiFetch(`${API_BASE_PATH}/notifications`, { headers: cabecerasDeEscritura(sesion) }),
  noLeidas: (sesion: SesionMe): Promise<{ count: number }> =>
    apiFetch(`${API_BASE_PATH}/notifications/unread-count`, { headers: cabecerasDeEscritura(sesion) }),
  leer: (sesion: SesionMe, id: string): Promise<unknown> =>
    apiFetch(`${API_BASE_PATH}/notifications/${id}/read`, {
      method: 'POST',
      headers: cabecerasDeEscritura(sesion),
    }),
};
